<template> </template>

<script>
import router from "@/router";
export default {
  mounted() {
    this.$api.auth.$axios.setToken(true, this.$route.query);
    setTimeout(() => {
      router.push({ path: "/client/orders" });
    }, 100);
  },
};
</script>
